import React from "react";
import { useParams, Link, useSearchParams } from "react-router-dom";
import YouTube from "react-youtube";
import theme from "../theme";

const styles = {
  card: {
    padding: theme.spacing.small,
    border: `1px solid #ddd`,
    borderRadius: "3px",
    backgroundColor: theme.colors.cardBackground,
    boxShadow: `0 2px 4px ${theme.colors.cardShadow}`,
    position: "relative",
    transition: "transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out",
    display: "flex",
    flexDirection: "column",
  },
  cardHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  cardTitle: {
    fontSize: "18px",
    color: theme.colors.accent,
    marginBottom: theme.spacing.small,
    marginTop: "0px",
  },
  cardMain: {
    color: theme.colors.text,
  },
  youtubeContainer: {
    marginTop: theme.spacing.small,
    borderRadius: "4px",
    overflow: "hidden",
  },
  difficultyLabel: {
    padding: "5px 10px",
    borderRadius: "12px",
    fontSize: "12px",
    fontWeight: "bold",
    color: "#fff",
  },
  difficultyColors: {
    1: {
      backgroundColor: "rgba(144, 238, 144, 0.8)", // Leichtes Grün
    },
    2: {
      backgroundColor: "rgba(173, 216, 230, 0.8)", // Leichtes Blau
    },
    3: {
      backgroundColor: "rgba(255, 223, 186, 0.8)", // Leichtes Orange
    },
    4: {
      backgroundColor: "rgba(255, 255, 153, 0.8)", // Leichtes Gelb
    },
    5: {
      backgroundColor: "rgba(255, 182, 193, 0.8)", // Leichtes Rot
    },
  },
};

const ExerciseDetails = ({ data }) => {
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  
  // Filter-Parameter für den Zurück-Link beibehalten
  const queryString = searchParams.toString();
  const backLink = queryString ? `/exercises?${queryString}` : '/exercises';

  const exercise = data.find((item) => item.Index === id);

  if (!exercise) {
    return <p>Übung nicht gefunden.</p>;
  }

  const getYouTubeVideoId = (url) => {
    if (!url) return null;
    const match =
      url.match(/(?:https?:\/\/)?(?:www\.)?youtube\.com\/watch\?v=([^&]+)/) ||
      url.match(/(?:https?:\/\/)?youtu\.be\/([^?]+)/);
    return match ? match[1] : null;
  };

  const videoId = getYouTubeVideoId(exercise["Short YouTube Demonstration"]);
  const difficultyStyle = styles.difficultyColors[exercise["Difficulty Level"]] || {};

  return (
    <div className="container">
      <div className="overlay"></div>
      <div className="content">
        <div style={styles.card}>
          <div style={styles.cardHeader}>
            <h3 style={styles.cardTitle}>{exercise.Exercise}</h3>
            <div style={{ ...styles.difficultyLabel, ...difficultyStyle }}>
              {exercise["Difficulty Level"]}
            </div>
          </div>
          <div className="exercise-details">
            {/* Linke Spalte: Text */}
            <div className="exercise-details-content" style={{ color: theme.colors.text }}>
              <p><strong>Primär Muskel:</strong> {exercise["Prime Mover Muscle"]}</p>
              <p><strong>Sekundär Muskel:</strong> {exercise["Secondary Muscle"]}</p>
              <p><strong>Tertiär Muskel:</strong> {exercise["Tertiary Muscle"]}</p>
              <p><strong>Mechanik:</strong> {exercise["Mechanics"]}</p>
              <p><strong>Bewegungsmuster:</strong> {exercise["Movement Pattern #1"]}</p>
              <p><strong>Benötigtes Equipment:</strong><br />{exercise["# Primary Items"]} {exercise["Primary Equipment"]}<br />{exercise["# Secondary Items"]} {exercise["Secondary Equipment"]}</p>
              <p><strong>Haltung:</strong> {exercise["Posture"]}</p>
              <p><strong>Ein oder Beidarmig:</strong> {exercise["Single or Double Arm"]}</p>
              <p><strong>abwechselnd:</strong> {exercise["Continuous or Alternating Arms"]}</p>
              <p><strong>Griff:</strong> {exercise["Grip"]}</p>
              <p><strong>Laststellung(Ende):</strong> {exercise["Load Position (Ending)"]}</p>
              <p><strong>abwechselnd Beine:</strong> {exercise["Continuous or Alternating Legs"]}</p>
              <p><strong>Fusserhöhung:</strong> {exercise["Foot Elevation"]}</p>
              <p><strong>Kombinationsübungen:</strong> {exercise["Combination Exercises"]}</p>
              <p><strong>Bewegungsmuster:</strong> {exercise["Movement Pattern #2"]}</p>
              <p><strong>Bewegungsmuster:</strong> {exercise["Movement Pattern #3"]}</p>
              <p><strong>Bewegungsebene:</strong> {exercise["Plane Of Motion #1"]}</p>
              <p><strong>Bewegungsebene:</strong> {exercise["Plane Of Motion #2"]}</p>
              <p><strong>Bewegungsebene:</strong> {exercise["Plane Of Motion #3"]}</p>
              <p><strong>Körperregion:</strong> {exercise["Body Region"]}</p>
              <p><strong>Kraftart:</strong> {exercise["Force Type"]}</p>
              <p><strong>Lateralität:</strong> {exercise["Laterality"]}</p>
              <p><strong>Klasse/Art:</strong> {exercise["Primary Exercise Classification"]}</p>
            </div>

            {/* Rechte Spalte: Video */}
            {videoId && (
              <div className="exercise-details-video" style={styles.youtubeContainer}>
                <YouTube videoId={videoId} opts={{ width: "100%", height: "315" }} />
              </div>
            )}
          </div>
          <Link to={backLink} className="back-link">
            ← Zurück zur Übersicht
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ExerciseDetails;